(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-free-samples"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('message',function(event){if(event.origin!=='https://formbuilder.hulkapps.com'||!event.data||event.data.source!=='liberty-welcome-kit'||event.data.type!=='kit_form_height')return;var frame=Array.from(document.querySelectorAll('.lc-kit-direct-frame')).find(function(el){return el.contentWindow===event.source;});if(frame&&Number.isFinite(event.data.height))frame.style.height=Math.min(4000,Math.max(250,event.data.height))+'px';});

  } catch(e) { console.error(e); }
})();
})();
